import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);

// Service Worker DISABLED on 2026-05-21.
// The previous SW was rewriting fetch responses and intermittently
// rejecting them with "Failed to convert value to 'Response'", which
// caused fake network errors on /api/* calls. We explicitly unregister
// any SW that may still be installed on a returning user.
serviceWorkerRegistration.unregister();
